<template>
    <div class="loopInfo">
        <div class="litter">基本信息</div>
        <div class="info">
            <div class="left">
                <div class="name">{{currentLoop.device_name}}</div>
                <div class="type" >
                    <p>容量：{{getQuery('容量')}}</p>
                    <p>型号：{{currentLoop.device_model_name}}</p>
                    <p>品牌：{{currentLoop.device_brand_name}}</p>
                    <p>站点：{{currentLoop.area_name}}</p>
                </div>
            </div>
            <div class="statue column-center">
                <div class="row-center" style="min-height:70px">
                    <div class="item">
                        <div class="name">UPS状态</div>
                        <div class="val grey" v-if="upsate=='--'">--</div>
                        <div class="val"  style="color:#FD4238" v-else-if="upsate">{{upsate}}</div>
                        <div class="val" v-else>正常</div>
                    </div>
                    <div class="item">
                        <div class="name">备电时间</div>
                        <div class="val " v-if="getQuery('备电时间')!='--'">{{getQuery('备电时间')}}</div>
                        <div class="val grey" v-else>--</div>
                    </div>
                </div>
                <div class="row-center">
                    <div class="item">
                        <div class="name" v-if="this.mqttval('buzzer_status')==1">蜂鸣器状态：<span style="color:#0D94FF">开</span></div>
                        <div class="name" v-else-if="this.mqttval('buzzer_status')==0">蜂鸣器状态：<span style="color:#FD4238">关</span></div>
                        <div class="name " v-else>蜂鸣器状态：<span class="grey">--</span></div>
                    </div>
                </div>
            </div>
            <div class="imgshow row-center"><img src="@/assets/img/UPS2.png" alt=""></div>
        </div>
        <div class="litter" style="border:0">运行状态</div>
        <div class="mapper">
            <div class="box row-center">
                <div class="plane1  row-center">
                    <div class="item">
                        <div class="name">UPS工作模式</div>
                        <div class="value">市电</div>
                    </div>
                    <div class="item">
                        <div class="name">蜂鸣器状态</div>
                        <div class="value">关</div>
                    </div>
                </div>
                <div class="plane2  colum-center">
                    <div class="title">电池</div>
                    <div class="foo row-center">
                        <div class="item">
                            <div class="name">SOC</div>
                            <div class="value">市电</div>
                        </div>
                        <div class="item">
                            <div class="name">SOH</div>
                            <div class="value">市电</div>
                        </div>
                        <div class="item">
                            <div class="name">充电状态</div>
                            <div class="value">市电</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="voltage row-center">
                <div class="plane plane1 row-center">
                    <div class="item">
                        <div class="name">输入电压(V)</div>
                        <div class="item">
                            <p>A<span>12.16</span></p>
                            <p>B<span>12.16</span></p>
                            <p>C<span>12.16</span></p>
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">输入电流(A)</div>
                        <div class="item">
                            <p>A<span>12.16</span></p>
                            <p>B<span>12.16</span></p>
                            <p>C<span>12.16</span></p>
                        </div>
                    </div>
                </div>
                <div class="plane plane2 row-center">
                    <div class="item">
                        <div class="name">输出频率(Hz)</div>
                        <div class="items">
                            <span>50.0</span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">输出电压(V)</div>
                        <div class="items">
                            <p>A<span>12.16</span></p>
                            <p>B<span>12.16</span></p>
                            <p>C<span>12.16</span></p>
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">输出电流(A)</div>
                        <div class="items">
                            <p>A<span>12.16</span></p>
                            <p>B<span>12.16</span></p>
                            <p>C<span>12.16</span></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="temperature row-center">
                <div class="item">
                    <div class="name">机内温度</div>
                    <div class="value">23℃</div>
                </div>
                <div class="item">
                    <div class="name">环境温度</div>
                    <div class="value">23℃</div>
                </div>
                <div class="item">
                    <div class="name">环境湿度</div>
                    <div class="value">23℃</div>
                </div>
                <div class="item">
                    <div class="name">烟感</div>
                    <div class="value">23℃</div>
                </div>
            </div>
            <div class="voltage voltage2 row-center">
                <div class="plane plane2 row-center">
                    <div class="item">
                        <div class="name">有功功率(kW)</div>
                        <div class="items">
                            <p>A<span>12.16</span></p>
                            <p>B<span>12.16</span></p>
                            <p>C<span>12.16</span></p>
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">视在功率(kVA)</div>
                        <div class="items">
                            <p>A<span>12.16</span></p>
                            <p>B<span>12.16</span></p>
                            <p>C<span>12.16</span></p>
                        </div>
                    </div>
                    <div class="item">
                        <div class="name">负载率(%)</div>
                        <div class="items">
                            <p>A<span>12.16</span></p>
                            <p>B<span>12.16</span></p>
                            <p>C<span>12.16</span></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { deviceAll,loopList,GetWireByDeviceID } from "../../api/power";
import { floatFormat } from "../../util/MathUtil";
import { subscribeByNodesUPS } from '../../mqtt/index'
import { json } from "body-parser";
  export default {
    props:{
        currentLoop:Object
    },
    components:{
        
    },
    data() {
      return {
        option:[
            {
                name:"电池电压",
                data:"U",
                unit:"V"
            },{
                name:"温度",
                data:"Temperature",
                unit:"℃"
            },{
                name:"频率",
                data:"INPUT_F",
                unit:"Hz"
            },{
                name:"输入电压",
                data:"INPUT_U",
                unit:"V"
            },{
                name:"输出电压",
                data:"OUT_U",
                unit:"V"
            },
            {
                name:"电流百分比",
                data:"OUT_I",
                unit:"%"
            },
        ],
      };
    },
    computed:{
        upsate(){
            let ste = []
            let name = ['关机总','测试中','在线互动式','UPS故障','旁路','电池电压低','市电故障']
            let data = ['shutdown','test','online_interactive','ups_error','bypass','low_battery_voltage','mains_electricity']
            data.forEach(item=>{
                let mqtt = this.mqttval(item)
                // if(mqtt=='1'){
                    ste.push(mqtt)
                // }
            })
            console.log(ste,"ste")
            if(ste.join(',').indexOf('1')>-1){  //有异常
                let news = []
                ste.map((e,i)=>{
                    if(e==1){
                        news.push(name[i])
                    }
                })
                return news.join(',')
            }else if(ste.join(',').indexOf('0')>-1){
                let news = []
                ste.map((e,i)=>{
                    if(e==1){
                        news.push(name[i])
                    }
                })
                return news.join(',')
            }else if(ste.join(',').indexOf('--')>-1){
                let news = []
                ste.map((e,i)=>{
                    if(e=='--'){
                        news.push(name[i])
                    }
                })
                if(news.length==ste.length){
                    return '--'
                }
            }
            // return ste.join(',')
        },
        getQuery(){
            return function(name){
                let data = JSON.parse(this.currentLoop.device_details)
                for (let arr in data) {
                    for (const [key, value] of Object.entries(data[arr])) {
                        if(key==name){
                            return value
                        }
                        // console.log(`${key}: ${value}`);
                    }
                }
            }
            
        },
        mqttval() {
			return this.getMqttVal(this.$store.getters.mqttVal);
		},
    },
    watch:{
        currentLoop(n,o){
            subscribeByNodesUPS([n.loop_url]);
        }
    },
    mounted(){
        if(this.currentLoop.loop_url){
            subscribeByNodesUPS([this.currentLoop.loop_url]);
        }
    },
    methods:{
        
        getMqttVal(f) {
			return (k, m) => {
				if (this.currentLoop && k) {
					k = this.currentLoop.loop_url + "/" + k;
                    let mqttVal = f(k);
                    if (m) {
                        mqttVal *= m;
                    }
                    mqttVal = floatFormat(mqttVal, 2);
                    if (typeof mqttVal === "object") {
                        return mqttVal;
                    }
                    return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
                } else {
                    return "--";
				}
			};
		},
    }
  };
</script>

<style scoped lang="less">
.loopInfo{
    width: 100%;
    height: 100%;
    overflow: auto;
    .litter{
        font-size: 18rem;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        padding-bottom: 0.6vh;
        border-bottom:1px solid rgba(0, 0, 0, 0.15) ;
        padding-left: 0.7vw;
        position: relative;
        color: #0D94FF;
        margin-bottom: 15px;
        &::before{
            content:'';
            width: 5rem;
            height: 2vh;
            background-color: #0D94FF;
            position: absolute;
            top: 40%;
            left: 0;
            transform: translate(0, -50%);
        }
    }
    .mapper{
        .item{
            text-align: center;
            .name{
                font-size: 16rem;
                line-height: 30rem;
            }
            .value{
                font-size: 18rem;
                font-weight: bold;
                color: #0D94FF;
                line-height: 30rem;
            }
        }
        .box{
            background: #F5F7F9;
            height: 150rem;
            justify-content: space-between;
            .plane1{
                .w(338);
                .item{
                    width: 45%
                }
            }
            .plane2{
                .w(500);
                text-align: center;
                .title{
                    font-size: 18px;
                    margin-bottom: 10px;
                }
                .item{
                    width: 30%
                }
            }
        }
        .voltage{
            // background: #F5F7F9;
            height: 150rem;
            margin: 16rem 0;
            justify-content: space-between;
            .name{
                text-align: left;
            }
            .item{
                text-align: left;
            }
            .plane{
                height: 150rem;
                background: #F5F7F9;
                p{
                    line-height: 30rem;
                    font-size: 16rem;
                    color: #666666;
                    span{
                        margin-left: 8px
                    }
                }
                
                span{
                    font-size: 18rem;
                    font-weight: bold;
                    color: #0D94FF;
                }
            }
            .plane1{
                .w(325);
                justify-content: space-evenly;
                .item{
                    width: 30%;
                }
            }
            .plane2{
                .w(500);
                justify-content: space-evenly;
                .item{
                    width: 20%;
                }
                .items{
                    height: 83px;
                }
            }
        }
        .temperature{
            background: #F5F7F9;
            height: 150rem;
            margin: 16rem 0;
            .item{
                width: 25%;
            }
        }
        .voltage2{
            background: #F5F7F9;
            height: 150rem;
            .plane2{
                width: 100%;
                justify-content: space-evenly;
            }
        }
    }
    

    .info{
        .h(180);
        justify-content: space-between;
        margin-bottom: 20px;
        .left{
            float: left;
            .name{
                font-size: 24rem;
                font-weight: bold;
                line-height: 45px;
            }
            .type{
                font-size: 18rem;
                font-weight: 400;
                color: #666666;
            }
        }
        .imgshow{
            .w(181);
            float: right;
            margin-right: 20px;
            height: 100%;
            background: #FFFFFF;
            border: 1px solid #E5E5E5;
            border-radius: 4px;
            img{
                max-height: 100%;
                max-width: 100%;
                transform: scale(1.3);
            }
        }
        .statue{
            .w(425);
            float: right;
            background: #f5f7f9;
            border-radius: 4px;
            height: 100%;
            text-align: center;
            .item{
                width: 50%;
            }
            .name{
                font-size: 18rem;
            }
            .row-center{
                align-items: flex-start;
                width: 100%;
            }
            .val{
                font-size: 18px;
                font-weight: 600;
                color: #0D94FF;
                // line-height: 55px;
            }
        }
    }
}
</style>